export default __webpack_public_path__ + "static/media/icon-SETTING.aaf8c90f.png";